<!-- Main Container with constrained width -->
<div class="w-full max-w-full">
  <!-- Compact Controls Section -->
  <div class="mb-3 w-full">
    <div class="flex items-center justify-between gap-2 flex-wrap">
      <!-- View mode buttons -->
      <div class="flex items-center gap-2">
      <!-- Filtro rápido de responsable -->
      <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
        <button
          type="button"
          (click)="setOwnerFilter('all')"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="filtroOwner === 'all'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Todos
        </button>
        <button
          type="button"
          (click)="setOwnerFilter('mine')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="filtroOwner === 'mine'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Mis contactos
        </button>
        <!-- inc38 — bandeja de los que entraron por un canal público y nadie ha reclamado.
             El literal es "Sin asignar", el mismo que muestra la ficha del contacto en
             Responsable: si el filtro dijera otra cosa el usuario no ataría los dos. -->
        <button
          type="button"
          (click)="setOwnerFilter('unassigned')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="filtroOwner === 'unassigned'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Sin asignar
        </button>
      </div>

      <button
        type="button"
        (click)="changeViewMode('contactCycle')"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
        [ngClass]="viewMode === 'contactCycle'
          ? 'bg-brand-500 text-white'
          : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
        Ciclo
      </button>
      <button
        type="button"
        (click)="changeViewMode('stateLead')"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
        [ngClass]="viewMode === 'stateLead'
          ? 'bg-brand-500 text-white'
          : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
        Estado Lead
      </button>
      <button
        type="button"
        (click)="changeViewMode('origin')"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
        [ngClass]="viewMode === 'origin'
          ? 'bg-brand-500 text-white'
          : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
        Origen
      </button>
    </div>

    <!-- Action buttons -->
    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        type="button"
        (click)="vistaLista()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
        </svg>
        Lista
      </button>
      <button
        type="button"
        (click)="nuevoContacto()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo
      </button>
    </div>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
  <div class="mb-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 w-full">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
    <!-- Búsqueda por nombre, correo o teléfono -->
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Buscar por nombre, correo o teléfono
      </label>
      <input
        type="text"
        [(ngModel)]="filters.searchTerm"
        (ngModelChange)="applyFilters()"
        placeholder="Nombre, correo o número..."
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
    </div>

    <!-- Filtro Estado de Contacto (solo si no es el modo actual) -->
    @if (availableFilterFields.stateLead) {
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Estado
      </label>
      <select
        [(ngModel)]="filters.idContactState"
        (ngModelChange)="applyFilters()"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="undefined">Todos</option>
        @for (state of contactStates; track state.id) {
        <option [ngValue]="state.id">{{ state.name }}</option>
        }
      </select>
    </div>
    }

    <!-- Filtro Ciclo de Contacto (solo si no es el modo actual) -->
    @if (availableFilterFields.contactCycle) {
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Ciclo
      </label>
      <select
        [(ngModel)]="filters.idContactCycle"
        (ngModelChange)="applyFilters()"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="undefined">Todos</option>
        @for (cycle of contactCycles; track cycle.id) {
        <option [ngValue]="cycle.id">{{ cycle.name }}</option>
        }
      </select>
    </div>
    }

    <!-- Filtro Origen (solo si no es el modo actual) -->
    @if (availableFilterFields.origin) {
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Origen
      </label>
      <select
        [(ngModel)]="filters.idOrigin"
        (ngModelChange)="applyFilters()"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="undefined">Todos</option>
        @for (origin of contactOrigins; track origin.id) {
        <option [ngValue]="origin.id">{{ origin.name }}</option>
        }
      </select>
    </div>
    }

    <!-- Filtro País (por prefijo telefónico) -->
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        País
      </label>
      <app-country-select
        [countries]="filterCountries"
        [value]="filtroPais"
        [clearable]="true"
        placeholder="Todos"
        (valueChange)="onCountryFilterChange($event)" />
    </div>

    <!-- Filtro por atributo custom (server-side JOIN, sin N+1) -->
    @if (attributeDefinitions.length > 0) {
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Atributo personalizado
      </label>
      <select
        [(ngModel)]="filtroAttributeDefinitionId"
        (ngModelChange)="onAttrDefChange()"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="undefined">— Ninguno —</option>
        @for (def of attributeDefinitions; track def.id) {
          <option [ngValue]="def.id">{{ def.name }}</option>
        }
      </select>
    </div>

    @if (selectedAttrDef) {
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Valor de "{{ selectedAttrDef.name }}"
        <span class="ml-1 font-normal text-gray-400">
          @if (selectedAttrDef.type === 'text' || selectedAttrDef.type === 'list') { · parcial }
          @if (selectedAttrDef.type === 'number' || selectedAttrDef.type === 'boolean') { · exacto }
        </span>
      </label>

      @if (selectedAttrDef.type === 'list') {
        <select [(ngModel)]="filtroAttrValue" (ngModelChange)="applyFilters()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="">Todos</option>
          @for (opt of parseListOptions(selectedAttrDef.listOptions); track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      }
      @if (selectedAttrDef.type === 'boolean') {
        <select [(ngModel)]="filtroAttrValue" (ngModelChange)="applyFilters()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="">Todos</option>
          <option value="true">Sí</option>
          <option value="false">No</option>
        </select>
      }
      @if (selectedAttrDef.type === 'text') {
        <input type="text" [(ngModel)]="filtroAttrValue" (ngModelChange)="applyFilters()"
          placeholder="Buscar texto..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      }
      @if (selectedAttrDef.type === 'number') {
        <input type="number" [(ngModel)]="filtroAttrValue" (ngModelChange)="applyFilters()"
          placeholder="Valor exacto"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      }
    </div>
    }
    }

    <!-- Botón Limpiar Filtros -->
    <div class="flex items-end">
      <button
        type="button"
        (click)="clearFilters()"
        class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
        Limpiar Filtros
      </button>
    </div>
    </div>
  </div>
  }

    <!-- Loading State -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
  </div>
  }

  <!-- Error State -->
  @if (error) {
  <div class="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-error-700 dark:text-error-400 px-4 py-3 rounded mb-6">
    {{ error }}
  </div>
  }

  <!-- Kanban Board with Horizontal Scroll -->
  @if (!loading && !error) {
  <div class="kanban-container overflow-x-auto w-full">
    <div class="flex gap-4 pb-4" style="min-width: fit-content;">
    @for (column of columns; track column.id; let colIndex = $index) {
  <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 min-w-72 w-72 flex-shrink-0">
    <!-- Header de la columna -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-2">
        <div class="w-3 h-3 rounded-full {{ column.color }}"></div>
        <h3 class="font-semibold text-gray-900 dark:text-white">{{ column.name }}</h3>
      </div>
      <span class="text-xs font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-1 rounded">
        {{ column.contacts.length }} contactos
      </span>
    </div>

    <!-- Lista de contactos con drag & drop -->
    <div
      cdkDropList
      [id]="'col-' + column.id"
      [cdkDropListData]="column.contacts"
      [cdkDropListConnectedTo]="getColumnIds()"
      (cdkDropListDropped)="drop($event, column)"
      class="min-h-125 max-h-175 overflow-y-auto space-y-3">

      @for (contact of column.contacts; track contact.id) {
      <div cdkDrag
        (click)="verDetalle(contact)"
        class="bg-white dark:bg-gray-900 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow relative group cursor-pointer">

        <!-- Botones de acción -->
        <div class="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
          <button type="button"
            (click)="editarContacto(contact, $event); $event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            class="p-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
            title="Editar">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
              </path>
            </svg>
          </button>
          <!-- El Kanban solo lista contactos activos: la acción es INACTIVAR, no eliminar.
               El borrado definitivo está en la pestaña "Inactivos" de la vista de lista. -->
          <button type="button"
            (click)="inactivarContacto(contact, $event); $event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            class="p-1.5 bg-warning-500 hover:bg-warning-600 text-white rounded transition-colors cursor-pointer"
            title="Inactivar">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4">
              </path>
            </svg>
          </button>
        </div>

        <!-- Nombre completo -->
        <h4 class="font-medium text-gray-900 dark:text-white mb-2 pr-20">
          {{ getFullName(contact) }}
        </h4>

        <!-- Email -->
        <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
            </path>
          </svg>
          <span class="truncate">{{ contact.mail }}</span>
        </div>

        <!-- Teléfono -->
        @if (contact.phone) {
        <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-3">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
            </path>
          </svg>
          @if (countryFlagCode(contact.phone); as cc) {
            <span class="fi fi-{{ cc }} rounded-sm shrink-0" [title]="countryName(contact.phone)"></span>
          }
          <span>{{ contact.phone }}</span>
        </div>
        }

        <!-- Badges según el modo de vista -->
        <div class="flex flex-wrap gap-2 mt-3">
          @if (viewMode !== 'stateLead' && contact.idContactState) {
          <app-badge color="info" size="sm">{{ getContactStateName(contact.idContactState) }}</app-badge>
          }
          @if (viewMode !== 'contactCycle' && contact.idContactCycle) {
          <app-badge color="success" size="sm">{{ getCycleName(contact.idContactCycle) }}</app-badge>
          }
          <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium"
            [class]="(contact.score ?? 0) >= 70 ? 'bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-400'
                   : (contact.score ?? 0) >= 40 ? 'bg-warning-100 text-warning-700 dark:bg-warning-900/30 dark:text-warning-400'
                   : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'">
            ★ {{ contact.score ?? 0 }}
          </span>
        </div>

        <!-- Indicador de arrastre -->
        <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 flex justify-center">
          <div class="w-8 h-1 bg-gray-300 dark:bg-gray-600 rounded"></div>
        </div>
      </div>
      }

      <!-- Estado vacío -->
      @if (column.contacts.length === 0 && !loading) {
      <div class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600">
        <svg class="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
          </path>
        </svg>
        <p class="text-sm">No hay contactos</p>
      </div>
      }

    </div>

  </div>
  }
  </div>
  </div>

  <!-- Paginación global -->
  @if (globalTotalPages >= 1) {
  <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
    <div class="flex items-center justify-between gap-4 flex-wrap">
      <div class="flex items-center gap-2">
        <span class="text-sm text-gray-500 dark:text-gray-400">
          {{ globalTotalElements }} registros
        </span>
        <select
          [ngModel]="pageSize"
          (ngModelChange)="changePageSize($event)"
          class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          @for (opt of PAGE_SIZE_OPTIONS; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button"
          (click)="cambiarPagina(globalPage - 1)"
          [disabled]="!hasPrevPage"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Anterior
        </button>
        <div class="flex items-center gap-1.5">
          <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
          <select
            [ngModel]="pageDisplay"
            (ngModelChange)="cambiarPagina($event - 1)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (p of pagesArray; track p) {
              <option [value]="p">{{ p }}</option>
            }
          </select>
          <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
        </div>
        <button type="button"
          (click)="cambiarPagina(globalPage + 1)"
          [disabled]="!hasNextPage"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Siguiente
        </button>
      </div>
    </div>
  </div>
  }
  }

  <!-- Modal de detalle -->
  <app-contacto-detail-modal
    [isOpen]="showDetailModal"
    [contact]="selectedContact"
    [contactStates]="contactStates"
    [contactCycles]="contactCycles"
    [contactOrigins]="contactOrigins"
    (close)="cerrarModalDetalle()">
  </app-contacto-detail-modal>
</div>
